import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';

import './scss/index.scss';
import StaticPage from '../component/static-page';
import Industry from './industry';
import CityAmount from './city-amount';
import CitySalary from './city-salary';
import CompanyTime from './company-time';
import ComapnyRank from './company-rank';
import HotRole from './hot-role';
import SectionBoundary from '../component/section-boundary';
import moDemandPdf from './store';
import { isEmpty } from 'lodash';
import moIndex from '../store';

interface IProps {}
interface IState {}

const HumanDemandPdf = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const {
    trendQuarter,
    cityRecruitList,
    companyIndsutryListTime,
    companyRankList,
    hotListTop30,
  } = moDemandPdf;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="human-demand-pdf">
      {(!isEmpty(trendQuarter) ||
      (!isEmpty(cityRecruitList) && !isEmpty(cityRecruitList.data)) ||
      (!isEmpty(cityRecruitList) && !isEmpty(cityRecruitList.data)) ||
      !isEmpty(companyIndsutryListTime) ||
      !isEmpty(companyRankList) ||
      !isEmpty(hotListTop30))      &&
      <StaticPage
        url="https://file.smartsalary.cn/index-pdf/06.png"
        head={true}
        onetitle="人力资源核心指标"
        showuuid={false}
        twotitle={moIndex.industry.name}/>}
      {!isEmpty(trendQuarter) && <SectionBoundary name="人才需求-行业"><Industry /></SectionBoundary>}
      {!isEmpty(cityRecruitList) && !isEmpty(cityRecruitList.data) && <SectionBoundary name="人才需求-城市招聘量"><CityAmount /></SectionBoundary>}
      {!isEmpty(cityRecruitList) && !isEmpty(cityRecruitList.data) && <SectionBoundary name="人才需求-城市招聘薪酬"><CitySalary /></SectionBoundary>}
      {!isEmpty(companyIndsutryListTime) && <SectionBoundary name="人才需求-企业时间趋势"><CompanyTime /></SectionBoundary>}
      {!isEmpty(companyRankList) && <SectionBoundary name="人才需求-企业排名"><ComapnyRank /></SectionBoundary>}
      {!isEmpty(hotListTop30) && <SectionBoundary name="人才需求-热门角色"><HotRole /></SectionBoundary>}
    </section>
  );
};

export default observer(HumanDemandPdf);
